






















import Vue from "vue";
import Component from "vue-class-component";
import Page from "@/components/layout/page.vue";
import OfficesTable from "@/components/tables/offices-table.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import TabsSettings from "@/components/tabs/settings.vue";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "offices",
    components: { TabsSettings, PageHeader, Page, OfficesTable },
})
export default class Offices extends Vue {}
